class MapUtil {
  static isValidCoordinate(coordinate) {
    const regex = /^-?\d+(\.\d+)?,\s*-?\d+(\.\d+)?$/;
    return regex.test(coordinate);
  }
  
  static strToCoordinate(coordinate) {
    const [latitude, longitude] = coordinate.split(',').map(Number);
    return {latitude, longitude};
  }
}